import { type TimeStateMachine, TimeStates } from "@/models/time-control/timeStateTypes";
import { setTimeList } from "@/time";
import type { DateTime } from "luxon";
import { Interval } from "luxon";
import type { StateFrom } from "xstate";

export function createTimeFramesFromState(timeState: StateFrom<TimeStateMachine>): DateTime[] {
  if (!timeState.matches(TimeStates.ANIMATION)) {
    return [];
  }
  const { startTime, endTime, temporalResolution } = timeState.context.modeOpts ?? {};
  // Defensive check:
  // startTime/endTime/temporalResolution may still be undefined if the ANIMATION
  // context was not fully initialized yet (e.g. on first page load).
  // In that case return an empty list instead of crashing with Luxon errors.
  if (!(startTime && endTime && temporalResolution)) {
    return [];
  }
  return setTimeList(Interval.fromDateTimes(startTime, endTime), temporalResolution);
}

export const isVideo = (mimeType: string): boolean => {
  if (mimeType.startsWith("video/")) {
    return true;
  }

  return false;
};
